(ns admin.events.containers.learner-activity-report-mock
  (:require [tick.alpha.api :as t]))

(def activity-uuid "demo")
(def rater-activity-uuid "rater-demo")

(def curriculum
  {:curriculum/name "PAVE"
   :curriculum/uuid "709f60fc-d28f-463c-8274-be2b1753e579"})

(def lo1-uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647")
(def lo2-uuid "16c6c141-e69b-4320-9a88-108acab6ef1b")
(def lo3-uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc")
(def lo4-uuid "d301df5c-1817-4283-81bd-67b14903e7ec")

(def rater-lo1-uuid "s781df5c-1817-4283-81bd-67b14903ek2c")
(def rater-lo2-uuid "v6l1df5c-1817-4283-81bd-67b14903e7aq")
(def rater-lo3-uuid "g741df5c-1817-4283-81bd-67b14903ebj5")

(def learning-objectives
  [{:learning-objective/uuid lo1-uuid
     :learning-objective/average-readiness 7.1
     :learning-objective/average-first-post-test-correct-count 1.2
     :learning-objective/description
     "Also know as SDR and SDV this review includes how to identify deviations appropriately, appropriate action, escalation and training if applicable, and what tools are available to assist in SDR and SDV."
     :learning-objective/average-first-pre-test-correct-count 1.3
     :learning-objective/label
     "Source Document Review & Source Data Verification"}
    {:learning-objective/uuid lo2-uuid
     :learning-objective/average-readiness 7.1
     :learning-objective/average-first-post-test-correct-count 1.8
     :learning-objective/description
     "Also known as EMRs, this review includes how to manage EMR and certify printed copies, Best Practice for spot checking copies against EMRs (per the CMP) if sites are printing source data from an EMR and the ALCOA Plus principles."
     :learning-objective/average-first-pre-test-correct-count 0.8
     :learning-objective/label "Electronic Medical Records"}
    {:learning-objective/uuid lo3-uuid
     :learning-objective/average-readiness 7.0
     :learning-objective/average-first-post-test-correct-count 1.7
     :learning-objective/description
     "A review of examples of Scientific and Data Misconduct, steps to take to escalate to QA and to your study team in the event of suspected misconduct as well as process and locations of SOP(s) pertaining to Scientific Misconduct."
     :learning-objective/average-first-pre-test-correct-count 1.3
     :learning-objective/label "Scientific Misconduct"}
    {:learning-objective/uuid lo4-uuid
     :learning-objective/average-readiness 6.8
     :learning-objective/average-first-post-test-correct-count 2
     :learning-objective/description
     "A quick review of the definitions related to Protocol Knowledge as well as where to find the protocol and understanding the portions specific to your role as Site Monitor."
     :learning-objective/average-first-pre-test-correct-count 1.1
     :learning-objective/label "Protocol Knowledge"}])

(def rater-learning-objectives
  [{:learning-objective/uuid rater-lo1-uuid
    :learning-objective/average-readiness 6.8
    :learning-objective/average-first-post-test-correct-count 2
    :learning-objective/description
    "Medicare Annual Wellness Visit Algorithm for Assessment of Cognition"
    :learning-objective/average-first-pre-test-correct-count 1.2
    :learning-objective/label "Algorithm for Assessment of Cognition"}
   {:learning-objective/uuid rater-lo2-uuid
    :learning-objective/average-readiness 6.8
    :learning-objective/average-first-post-test-correct-count 2
    :learning-objective/description
    "Patient assessment: Mini-Cog or GPCOG"
    :learning-objective/average-first-pre-test-correct-count 1.3
    :learning-objective/label "Brief Structured Patient Assessment"}
   {:learning-objective/uuid rater-lo3-uuid
    :learning-objective/average-readiness 6.8
    :learning-objective/average-first-post-test-correct-count 2
    :learning-objective/description
    "Informant assessment of patient: Short IQCODE, AD8 or GPCOG"
    :learning-objective/average-first-pre-test-correct-count 1.4
    :learning-objective/label "Brief Structured Caregiver Interview"}])

(def moment-question-1
  {:moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"
   :moment/type "question"
   :moment/learning-objective {:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647"}
   :moment/resources []
   :moment/question {:question/other-enabled false
    :question/type "single-answer"
    :question/has-correctness true
    :question/key false
    :question/educator-feedback
    "<p><span><strong>Source Document</strong></span><span> </span><span><strong>Review is the </strong></span><span>review of subject medical records, worksheets and progress notes. Missed procedures or non-compliance issues can be found while conducting SDR which may not otherwise be found when only conducting SDV. </span><span><strong>Source Data</strong></span><span> </span><span><strong>Verification is the confirmation of </strong></span><span>the accuracy and completeness of the Case Report Form (CRF) based on review of source documents, and other trial-related records. While SDV and SDR are both important parts of the monitoring schema, the two terms refer to different activities.&nbsp;</span></p>"
    :question/choices
    [{:question.choice/uuid "411ef908-19a8-4649-853a-ba835c9b9557"
      :question.choice/correct? false
      :question.choice/index 0
      :question.choice/body "True"}
     {:question.choice/uuid "bf72cee9-596f-4a27-95a7-6adffaadf5c2"
      :question.choice/correct? true
      :question.choice/index 1
      :question.choice/body "False"}]
    :question/body
    "<p><span>SDV and SDR are the same. </span><span><strong>TRUE or FALSE?</strong></span></p>",
    :question/results
    {:educator-feedback
     "<p><span><strong>Source Document</strong></span><span> </span><span><strong>Review is the </strong></span><span>review of subject medical records, worksheets and progress notes. Missed procedures or non-compliance issues can be found while conducting SDR which may not otherwise be found when only conducting SDV. </span><span><strong>Source Data</strong></span><span> </span><span><strong>Verification is the confirmation of </strong></span><span>the accuracy and completeness of the Case Report Form (CRF) based on review of source documents, and other trial-related records. While SDV and SDR are both important parts of the monitoring schema, the two terms refer to different activities.&nbsp;</span></p>"
     :correct-answer "bf72cee9-596f-4a27-95a7-6adffaadf5c2"}
    :question/correct-answer {:question.choice/index 1}
    :question/uuid "11300f21-e367-4f7f-84c4-b6ad60b18dea"}
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
     :question.aggregates.response/sure-count 0
     :question.aggregates.response/choice
     {:question.choice/uuid "411ef908-19a8-4649-853a-ba835c9b9557"}
     :question.aggregates.response/guess-count 10
     :question.aggregates.response/unsure-count 0}
    {:question.aggregates.response/no-confidence-count 0
     :question.aggregates.response/sure-count 4
     :question.aggregates.response/choice
     {:question.choice/uuid "bf72cee9-596f-4a27-95a7-6adffaadf5c2"}
     :question.aggregates.response/guess-count 0
     :question.aggregates.response/unsure-count 0}]
   :question.aggregates/percent-correct 0})

(def moment-question-2
  {:moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"
   :moment/type "question"
   :moment/learning-objective {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec"}
   :moment/resources []
   :moment/question {:question/other-enabled false
                     :question/type "single-answer"
                     :question/has-correctness true
                     :question/key false
                     :question/educator-feedback
                     "<p><span>Both the Inclusion/ Exclusion Criteria sections and the schedule of events contain information the Site Monitor will need to know well and apply on a daily basis. While the Statistical analysis plan is an important part of every protocol, the site monitor is not responsible for the analysis of the data and does not need to be as knowledgeable on this section.</span></p>"
                     :question/choices
                     [{:question.choice/uuid "0e6aa9ac-469b-4ede-9154-7645cc4957fe"
                       :question.choice/correct? false
                       :question.choice/index 0
                       :question.choice/body "The Inclusion and Exclusion Criteria"}
                      {:question.choice/uuid "64f26818-e29e-4eb0-8723-cc78c41e18aa"
                       :question.choice/correct? false
                       :question.choice/index 1
                       :question.choice/body "The schedule of Events"}
                      {:question.choice/uuid "90aace20-14ea-4823-9449-463afd90dde6"
                       :question.choice/correct? false
                       :question.choice/index 2
                       :question.choice/body "The Statistical Analysis Plan"}
                      {:question.choice/uuid "3891cb58-27e2-465c-82e3-46fe1262f5f1"
                       :question.choice/correct? true
                       :question.choice/index 3
                       :question.choice/body "Both 1 & 2"}]
                     :question/body
                     "<p><span>Key aspects of the protocol, which the site monitor should be knowledgeable in include which of the following?</span></p>"
                     :question/results
                     {:educator-feedback
                      "<p><span>Both the Inclusion/ Exclusion Criteria sections and the schedule of events contain information the Site Monitor will need to know well and apply on a daily basis. While the Statistical analysis plan is an important part of every protocol, the site monitor is not responsible for the analysis of the data and does not need to be as knowledgeable on this section.</span></p>"
                      :correct-answer "3891cb58-27e2-465c-82e3-46fe1262f5f1"}
                     :question/correct-answer {:question.choice/index 3}
                     :question/uuid "1c317d07-761b-4880-9218-4bd50f11357e"}
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 1
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "0e6aa9ac-469b-4ede-9154-7645cc4957fe"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 1
                                    :question.aggregates.response/sure-count 3
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "90aace20-14ea-4823-9449-463afd90dde6"}
                                    :question.aggregates.response/guess-count 1
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 1
                                    :question.aggregates.response/sure-count 4
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "3891cb58-27e2-465c-82e3-46fe1262f5f1"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 0}]
   :question.aggregates/percent-correct 0})

(def raters-moment-question-1
  {:moment/uuid "s4h7d3cf-eeb9-4fce-a7e6-58f55ab5f2hg"
   :moment/type "question"
   :moment/learning-objective {:learning-objective/uuid "s781df5c-1817-4283-81bd-67b14903ek2c"}
   :moment/resources []
   :moment/question {:question/other-enabled false
                     :question/type "single-answer"
                     :question/has-correctness true
                     :question/key false
                     :question/educator-feedback
                     "<p><span>In the absence of an informant available to confirm signs/symptoms or administer informant assessments on, providers should move to step C - refer or conduct a full evaluation on the patient as a score if 4 on the GPCOG indicates potential cognitive impairment.&nbsp;</span></p>"
                     :question/choices
                     [{:question.choice/uuid "dt5ef908-19a8-4649-853a-ba835c9b9g3j"
                       :question.choice/correct? false
                       :question.choice/index 0
                       :question.choice/body "A: Repeat the GPCOG to confirm the accuracy of the results"}
                      {:question.choice/uuid "kt62cee9-596f-4a27-95a7-6adffaadfey7"
                       :question.choice/correct? false
                       :question.choice/index 1
                       :question.choice/body "B: Administer the Short IQCODE with the patient"}
                      {:question.choice/uuid "v6p2cee9-596f-4a27-95a7-6adffaadfw6g"
                       :question.choice/correct? true
                       :question.choice/index 2
                       :question.choice/body "C: Refer OR conduct full dementia evaluation"}]
                     :question/body
                     "<p>Refer to the algorithm presented here to answer the question below:</p><p>Your patient presents with concerns of cognitive impairtment, there is no informant available to confirm.  The patient scores a 4 on the GPCOG.</p><p>What next step should be taken?</p>",
                     :question/results
                     {:educator-feedback
                      "<p><span>In the absence of an informant available to confirm signs/symptoms or administer informant assessments on, providers should move to step C - refer or conduct a full evaluation on the patient as a score if 4 on the GPCOG indicates potential cognitive impairment.&nbsp;</span></p>"
                      :correct-answer "v6p2cee9-596f-4a27-95a7-6adffaadfw6g"}
                     :question/correct-answer {:question.choice/index 2}
                     :question/uuid "dy600f21-e367-4f7f-84c4-b6ad60b18ti8"}
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 0
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "dt5ef908-19a8-4649-853a-ba835c9b9g3j"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 0
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "v6p2cee9-596f-4a27-95a7-6adffaadfw6g"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 1}]
   :question.aggregates/percent-correct 0})

(def raters-moment-question-2
  {:moment/uuid "d827d3cf-eeb9-4fce-a7e6-58f55ab5fl1w"
   :moment/type "question"
   :moment/learning-objective {:learning-objective/uuid "v6l1df5c-1817-4283-81bd-67b14903e7aq"}
   :moment/resources []
   :moment/question {:question/other-enabled false
                     :question/type "single-answer"
                     :question/has-correctness true
                     :question/key false
                     :question/educator-feedback
                     "<p><span>According to the Mini-Cog scoring guidelines, only scores of 0 or 2 or given.  A score of 1 is not given to this assessment.  In the example given above, the drawing has all the numbers in the correct place, but the hands are not pointing to the correct time.  A score of 0 should be given.&nbsp;</span></p>"
                     :question/choices
                     [{:question.choice/uuid "411ef908-19a8-4649-853a-ba835c9b9557"
                       :question.choice/correct? true
                       :question.choice/index 0
                       :question.choice/body "0"}
                      {:question.choice/uuid "bf72cee9-596f-4a27-95a7-6adffaadf5c2"
                       :question.choice/correct? false
                       :question.choice/index 1
                       :question.choice/body "1"}
                      {:question.choice/uuid "dy62cee9-596f-4a27-95a7-6adffaadfg89"
                       :question.choice/correct? false
                       :question.choice/index 2
                       :question.choice/body "2"}]
                     :question/body
                     "<p><span>Refer to the clock drawing presented above - what score would you give this drawing according to the Mini-Cog scoring guidelines?</span></p>",
                     :question/results
                     {:educator-feedback
                      "<p><span>According to the Mini-Cog scoring guidelines, only scores of 0 or 2 or given.  A score of 1 is not given to this assessment.  In the example given above, the drawing has all the numbers in the correct place, but the hands are not pointing to the correct time.  A score of 0 should be given.&nbsp;</span></p>"
                      :correct-answer "411ef908-19a8-4649-853a-ba835c9b9557"}
                     :question/correct-answer {:question.choice/index 0}
                     :question/uuid "d2t00f21-e367-4f7f-84c4-b6ad60b18k9p"}
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 1
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "411ef908-19a8-4649-853a-ba835c9b9557"}
                                    :question.aggregates.response/guess-count 1
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 0
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "bf72cee9-596f-4a27-95a7-6adffaadf5c2"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 0}]
   :question.aggregates/percent-correct 0})

(def moments
  [moment-question-1 moment-question-2])

(def rater-moments
  [raters-moment-question-1 raters-moment-question-2])


(def post-test-q1
  {:question.context/uuid "9e3dc214-cf0f-4225-9ef8-2260a209824f"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo4-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 5,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "fae51b5a-b47f-425f-98b7-94fc6e2a3504"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "57215d25-3bac-4d21-8c20-7c8ee2000502"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 2}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "dcb33f76-d792-4c0c-a6f9-a24861a50837"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key true,
                               :question/educator-feedback "<p><span>Following the Protocol requirements, QTC prolongation should be reported as an SAE in case &nbsp;triplicate ECG shows an average QTC of &gt;500ms, with a confirmatory triplicate ECG within 2 hours showing an average QTC of &gt;500ms. At first ECG an avarage QTC was 501ms which meets SAE criteria, however at a confirmatory triplicate ECG an average QTC was 493ms. Thus SAE was not confirmed, but an AE should be reported as an avarage of any QTC prolongation triplicate average exceeds 450ms. Also the site should complete a deviation as the second triplicate ECG was done 3 hours after the first one though protocol requires a confirmatory triplicate ECG within 2 hours.&nbsp;</span></p>",
                               :question/choices [{:question.choice/uuid "57215d25-3bac-4d21-8c20-7c8ee2000502",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "Site staff should have reported the event to the Safety Group as an SAE within 24 hours of the event"}
                                                  {:question.choice/uuid "fae51b5a-b47f-425f-98b7-94fc6e2a3504",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "Site staff should have reported an AE and a deviation for an out of window 2 hour confirmatory ECG"}
                                                  {:question.choice/uuid "dcb33f76-d792-4c0c-a6f9-a24861a50837",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "Site staff should have reported the event as a serious adverse event for the first triplicate ECG and register an AE for the second triplicate ECG"}
                                                  {:question.choice/uuid "1d732574-2dbc-4283-a2a7-05d28775c5fc",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Site staff should have performed a third ECG triplicate"}],

                               :question/body "<p><span>A Site Monitor is monitoring a study where a known adverse drug reaction is QTC prolongation. The protocol states QTC prolongation should be reported as an SAE if a triplicate ECG shows an average QTC of &gt;500ms, with a confirmatory triplicate ECG within 2 hours showing an average QTC of &gt;500ms. The protocol also states that, if an avarage of any QTC prolongation triplicate average that does not meet the criteria for an SAE but exceeds 450ms, it should be reported as an adverse event. The CRA is onsite monitoring and sees that a subject had a triplicate ECG at 10:00 with QTC results of 494, 511, and 498. The next triplicate ECG was performed at 13:00. The QTC results were 515, 465, and 499. What documentation would the Site Monitor expect to see on site?</span></p>",

                               :question/results {:educator-feedback
                                                  "<p><span>Following the Protocol requirements, QTC prolongation should be reported as an SAE in case &nbsp;triplicate ECG shows an average QTC of &gt;500ms, with a confirmatory triplicate ECG within 2 hours showing an average QTC of &gt;500ms. At first ECG an avarage QTC was 501ms which meets SAE criteria, however at a confirmatory triplicate ECG an average QTC was 493ms. Thus SAE was not confirmed, but an AE should be reported as an avarage of any QTC prolongation triplicate average exceeds 450ms. Also the site should complete a deviation as the second triplicate ECG was done 3 hours after the first one though protocol requires a confirmatory triplicate ECG within 2 hours.&nbsp;</span></p>",
                                                  :correct-answer "fae51b5a-b47f-425f-98b7-94fc6e2a3504"},
                               :question/correct-answer {:question.choice/index 1},
                               :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}})

(def post-test-q2
  {:question.context/uuid "231cf27d-0105-48f7-9656-da3aaf296718"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo4-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "eecc5fda-65d9-4643-ae23-ed4c48e9617f"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 3,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "c133362c-816f-4de9-a398-29b41cf71549"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 14,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "a95540b6-b24f-4c1d-8907-5a030291c277"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key true,
                               :question/educator-feedback "<p><span>As per SOP WI Interim Monitoring Visit (IMV) if an ineligible subject is enrolled, the Site Monitor immediately escalates to the CTM per PMP/CMP, documents and enters the protocol deviation into the CTMS as per the SOP Protocol Deviation Management, the CMP, Medical Monitoring Plan and Protocol Deviation guidance document. Also the Site Monitor should notifies the Medical Monitor, if applicable, and instructs the site staff to notify the EC as appropriate.</span></p>",
                               :question/choices [{:question.choice/uuid "5916ce6c-8669-4a98-81ae-90f5438ad565",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "Instruct the site to notify the subject and discontinue IP immediately"}
                                                  {:question.choice/uuid "a95540b6-b24f-4c1d-8907-5a030291c277",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "Confirm and Document a Protocol Deviation in the System of Record"}
                                                  {:question.choice/uuid "eecc5fda-65d9-4643-ae23-ed4c48e9617f",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "Verify that the site has followed their standard of care procedures"}
                                                  {:question.choice/uuid "c133362c-816f-4de9-a398-29b41cf71549",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Verify the PI has documented his assessment of clinical significance"}],

                               :question/body "<p><span>Inclusion criteria stipulates that a potential subject’s TSH [Thyroid stimulating hormone] must be &lt;3.0uIU/mL. The Principal Investigator (PI) decides to enroll a subject with a TSH of 3.3uIU/mL because the upper range is varied by many factors and the difference is not considered clinically significant. What action should the Site Monitor take?</span></p>",
                               :question/results {:educator-feedback
                                                  "<p><span>As per SOP WI Interim Monitoring Visit (IMV) if an ineligible subject is enrolled, the Site Monitor immediately escalates to the CTM per PMP/CMP, documents and enters the protocol deviation into the CTMS as per the SOP Protocol Deviation Management, the CMP, Medical Monitoring Plan and Protocol Deviation guidance documnet. Also the Site Monitor should notifies the Medical Monitor, if applicable, and instructs the site staff to notify the EC as appropriate.</span></p>",
                                                  :correct-answer "a95540b6-b24f-4c1d-8907-5a030291c277"},
                               :question/correct-answer {:question.choice/index 1},
                               :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}})

(def post-test-q3
  {:question.context/uuid "38554624-2cd3-4c10-a4ef-a44b8a172712"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo3-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 7,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "d0f11724-2022-4899-9b90-0b74fa39612e"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "422d1944-f447-4b1c-86de-48c942ca9ef7"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "25140047-a949-4991-93a7-fb6ef3828da1"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key true,
                               :question/educator-feedback "<p><span>Per SOP Management of Significant GxP Issues, misconduct is defined as: Untruthful acts such as falsification (e.g., the conscious altering) or fabrication (e.g., generating data that does not exist) of data or information so that it no longer reflects the truth. Additionally, the conscious omission of data that would otherwise be reported is also considered an untruthful act. Such acts do not need to persist to be serious and therefore should be promptly escalated. See SOP Guidance for Reportable Misconduct.&nbsp;</span></p>\n<p><span>Deliberate acts demonstrating disregard for important aspects of GxP, especially those that relate to risks to trial participants or data integrity, can also be considered misconduct. These do not need to persist to be escalated. See SOP Guidance for Reportable Misconduct.</span></p>",
                               :question/choices [{:question.choice/uuid "d0f11724-2022-4899-9b90-0b74fa39612e",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "Backdating or signing source or study documents for someone else"}
                                                  {:question.choice/uuid "422d1944-f447-4b1c-86de-48c942ca9ef7",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "PI continues to allow data to be generated by individuals not qualified by training or experience"}
                                                  {:question.choice/uuid "25140047-a949-4991-93a7-fb6ef3828da1",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "Persistent failure to adequately store and document investigational supply receipt and distribution"}
                                                  {:question.choice/uuid "45f853cc-0b1f-4028-90dc-3415d44d200d",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Failure to perform protocol-required tests despite being reminded"}],
                               :question/body "<p><span>Which of the following is an example of Intentional Falsification of Data?&nbsp;</span></p>",
                               :question/results {:educator-feedback "<p><span>Per SOP Management of Significant GxP Issues, misconduct is defined as: Untruthful acts such as falsification (e.g., the conscious altering) or fabrication (e.g., generating data that does not exist) of data or information so that it no longer reflects the truth. Additionally, the conscious omission of data that would otherwise be reported is also considered an untruthful act. Such acts do not need to persist to be serious and therefore should be promptly escalated. See SOP Guidance for Reportable Misconduct.&nbsp;</span></p>\n<p><span>Deliberate acts demonstrating disregard for important aspects of GxP, especially those that relate to risks to trial participants or data integrity, can also be considered misconduct. These do not need to persist to be escalated. See SOP Guidance for Reportable Misconduct.</span></p>",
                                                  :correct-answer "d0f11724-2022-4899-9b90-0b74fa39612e"},
                               :question/correct-answer {:question.choice/index 0},
                               :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}})

(def post-test-q4
  {:question.context/uuid "96943d34-25d1-4ca0-bf43-0da7d51de3c4"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo2-uuid}
   :question.aggregates/percent-correct 0.87
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 0,
                                    :question.aggregates.response/choice
                                    [{:question.choice/uuid "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78"}
                                     {:question.choice/uuid "630ee5a4-b6f7-4cbe-8920-7c02f42a87a7"}
                                     {:question.choice/uuid "e62b6d21-bea6-4745-9b48-95b2b12a6776"}
                                     {:question.choice/uuid
                                      "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9"}],
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 0,
                                    :question.aggregates.response/choice
                                    [{:question.choice/uuid "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78"}
                                     {:question.choice/uuid "e62b6d21-bea6-4745-9b48-95b2b12a6776"}
                                     {:question.choice/uuid
                                      "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9"}],
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 3,
                                    :question.aggregates.response/choice
                                    [{:question.choice/uuid "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78"}
                                     {:question.choice/uuid "630ee5a4-b6f7-4cbe-8920-7c02f42a87a7"}
                                     {:question.choice/uuid "a873a15b-1a2f-47c4-9164-1f9eb49c7cb6"}
                                     {:question.choice/uuid "e62b6d21-bea6-4745-9b48-95b2b12a6776"}
                                     {:question.choice/uuid
                                      "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9"}],
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 0,
                                    :question.aggregates.response/choice
                                    [{:question.choice/uuid "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78"}
                                     {:question.choice/uuid "a873a15b-1a2f-47c4-9164-1f9eb49c7cb6"}
                                     {:question.choice/uuid "e62b6d21-bea6-4745-9b48-95b2b12a6776"}
                                     {:question.choice/uuid
                                      "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9"}],
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "multiple-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>Explanation: Following ICH GCP section 5.18.4 a Site Monitor should ensure that the trial is conducted and documented properly by verifying that source documents and other trial rexords are acuaret, complete, kept up-to-date and maintained, and berifying that the invesigator provides all the required reports, notifications, applications, submissions, and that these documnrs are accurate, complete, timeply, legible, dated, and identify the trial (Ref: 5.18.4 i,j)</span></p>",
                               :question/choices [{:question.choice/uuid "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "Review of AE logs including progress notes"}
                                                  {:question.choice/uuid "e62b6d21-bea6-4745-9b48-95b2b12a6776",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 1,
                                                   :question.choice/body "Diaries"}
                                                  {:question.choice/uuid "630ee5a4-b6f7-4cbe-8920-7c02f42a87a7",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 2,
                                                   :question.choice/body "Lab reports"}
                                                  {:question.choice/uuid "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Certified copies of the electronical medical record"}
                                                  {:question.choice/uuid "a873a15b-1a2f-47c4-9164-1f9eb49c7cb6",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 4,
                                                   :question.choice/body
                                                   "Clinic notes for an unscheduled non study specific visit"}],

                               :question/body "<p><span>A Site Monitor must request to review ALL medical records, paper and electronic, to confirm that all trial related procedures have been conducted and that there were no additional observations noted for the subject between visits. Select all applicable records required to be requested:&nbsp;</span></p>",
                               :question/results {:educator-feedback
                                                  "<p><span>Explanation: Following ICH GCP section 5.18.4 a Site Monitor should ensure that the trial is conducted and documented properly by verifying that source documents and other trial rexords are acuaret, complete, kept up-to-date and maintained, and berifying that the invesigator provides all the required reports, notifications, applications, submissions, and that these documnrs are accurate, complete, timeply, legible, dated, and identify the trial (Ref: 5.18.4 i,j)</span></p>",
                                                  :correct-answer ["a873a15b-1a2f-47c4-9164-1f9eb49c7cb6"
                                                                   "fd52a67d-0f33-4c2d-a7ae-7352cbadc6b9"
                                                                   "630ee5a4-b6f7-4cbe-8920-7c02f42a87a7"
                                                                   "e62b6d21-bea6-4745-9b48-95b2b12a6776"
                                                                   "06e5e77d-46ae-4e65-9f2e-cfbfd8d21b78"]},
                               :question/correct-answer [{:question.choice/index 4}
                                                         {:question.choice/index 3}
                                                         {:question.choice/index 2}
                                                         {:question.choice/index 1}
                                                         {:question.choice/index 0}],

                               :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}})

(def post-test-q5
  {:question.context/uuid "e93f41aa-c4ef-4e6f-babe-8c89c1e59246"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo3-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses nil
   :question.context/question {:question/other-enabled false,
                               :question/type "free-response",
                               :question/has-correctness false,
                               :question/key false,
                               :question/educator-feedback nil,
                               :question/choices [],
                               :question/body "<p><span>Name one example of Intentional Falsification of Data.</span></p>"
                               :question/results nil,
                               :question/correct-answer nil,
                               :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}})

(def post-test-q6
  {:question.context/uuid "5d0e40e3-0d5f-4637-acbe-e0347f4926a0"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo4-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "03a56bec-b885-4cfa-bcde-3dd65f666de0"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 2}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 17,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "9a553ef0-373e-467c-89e2-501a0781e60a"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "e873b1b9-f5cb-486e-ac51-87016873c963"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "15ec774f-5550-4bba-a6bc-f42ae52c49b9"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>Per calculations, 65 kg x 10% = 6.5 kg</span></p>\n<p><span>Therefore, if there is more than +/- 6.5 kg change in weight, it would require a change in dose.&nbsp;</span></p>\n<p><span>Screening: 65 kg</span></p>\n<p><span>Visit 1: 65 kg</span></p>\n<p><span>Visit 2: 58 kg (65-58 = 7 kg change)</span></p>\n<p><span>New dose at Visit 2: 58 kg x 6 mg/kg = 348 mg</span></p>",
                               :question/choices [{:question.choice/uuid "9a553ef0-373e-467c-89e2-501a0781e60a",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 0,
                                                   :question.choice/body "348mg"}
                                                  {:question.choice/uuid "03a56bec-b885-4cfa-bcde-3dd65f666de0",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body "351mg"}
                                                  {:question.choice/uuid "e873b1b9-f5cb-486e-ac51-87016873c963",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body "372mg"}
                                                  {:question.choice/uuid "15ec774f-5550-4bba-a6bc-f42ae52c49b9",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body "390mg"}],

                               :question/body "<p><span>Per study protocol, subjects are to receive 6mg/kg of study drug every four weeks. The subject's weight at screening should be used to determine the study drug dose unless there is a &gt;10% weight change from the Screening weight.&nbsp;At Screening and Visit 1 the subject weighed 65kg and was given 390mg of study drug. At Visit 2, the subject weighs 58kg. What would be the correct dose of study drug for Visit 2?&nbsp;</span></p>",

                               :question/results {:educator-feedback
                                                  "<p><span>Per calculations, 65 kg x 10% = 6.5 kg</span></p>\n<p><span>Therefore, if there is more than +/- 6.5 kg change in weight, it would require a change in dose.&nbsp;</span></p>\n<p><span>Screening: 65 kg</span></p>\n<p><span>Visit 1: 65 kg</span></p>\n<p><span>Visit 2: 58 kg (65-58 = 7 kg change)</span></p>\n<p><span>New dose at Visit 2: 58 kg x 6 mg/kg = 348 mg</span></p>",
                                                  :correct-answer "9a553ef0-373e-467c-89e2-501a0781e60a"},
                               :question/correct-answer {:question.choice/index 0}
                               :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}})

(def post-test-q7
  {:question.context/uuid "36973c59-4302-4d4e-bb47-0f901568841b"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo3-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 3,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "810acf54-2a2f-468d-a115-34702b2d2c9c"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 0,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "3d6d454b-b0b1-43d5-9b58-171130e9a188"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>Per SOP Management of Significant GxP Issues, Persistent non-compliance is a form a form of Misconduct. It is typically associated with gross negligence or a willful disregard to take corrective measures despite awareness, counseling, or retraining. Examples include, but are not limited to:</span></p>\n<ul>\n  <li><span>Continued failure to perform required tests or assessments despite being reminded and/or being re-trained.</span></li>\n  <li><span>Purposefully enrolling subjects outside of entrance criteria.</span></li>\n  <li><span>Allowing data to be generated by individuals not qualified by training or experience which is not due to a one time/unique situation.</span></li>\n  <li><span>Systemic failure to collect and/or promptly report safety information/incidents (e.g. Adverse Events) to the Sponsor,</span></li>\n  <li><span>Investigator(s), regulatory agencies, data monitoring committees, Ethics Committees, and others.</span></li>\n  <li><span>Inadequate informed consent practices that are repetitive and/or egregious in nature, including situations where there is a systemic breakdown in the informed consent process with broad impact.</span></li>\n  <li><span>Incorrect/inappropriate management of investigational product that results in trial participants or study results being put at risk and/or is systemic or repetitive in nature. Typically associated with cases where the Investigational Product has been compromised.</span></li>\n</ul>",
                               :question/choices [{:question.choice/uuid "810acf54-2a2f-468d-a115-34702b2d2c9c",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "Failing to perform required tests or assessments despite being reminded and/or being re-trained"}
                                                  {:question.choice/uuid "3d6d454b-b0b1-43d5-9b58-171130e9a188",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "Conducting a visit outside of window to accommodate the subject's work schedule"}
                                                  {:question.choice/uuid "9ebb24ee-a8c1-4530-823c-54f58c7c1803",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "Withholding Investigational Product  following an adverse event"}
                                                  {:question.choice/uuid "9ce77f6f-884b-490a-97cf-fc93dfc9d717",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Recording data that does not reflect the original data collected"}]

                               :question/body "<p><span>Which of the following is an example of persistent non-compliance?&nbsp;</span></p>",
                               :question/results {:educator-feedback
                                                  "<p><span>Per SOP Management of Significant GxP Issues, Persistent non-compliance is a form a form of Misconduct. It is typically associated with gross negligence or a willful disregard to take corrective measures despite awareness, counseling, or retraining. Examples include, but are not limited to:</span></p>\n<ul>\n  <li><span>Continued failure to perform required tests or assessments despite being reminded and/or being re-trained.</span></li>\n  <li><span>Purposefully enrolling subjects outside of entrance criteria.</span></li>\n  <li><span>Allowing data to be generated by individuals not qualified by training or experience which is not due to a one time/unique situation.</span></li>\n  <li><span>Systemic failure to collect and/or promptly report safety information/incidents (e.g. Adverse Events) to the Sponsor,</span></li>\n  <li><span>Investigator(s), regulatory agencies, data monitoring committees, Ethics Committees, and others.</span></li>\n  <li><span>Inadequate informed consent practices that are repetitive and/or egregious in nature, including situations where there is a systemic breakdown in the informed consent process with broad impact.</span></li>\n  <li><span>Incorrect/inappropriate management of investigational product that results in trial participants or study results being put at risk and/or is systemic or repetitive in nature. Typically associated with cases where the Investigational Product has been compromised.</span></li>\n</ul>",
                                                  :correct-answer "810acf54-2a2f-468d-a115-34702b2d2c9c"}
                               :question/correct-answer {:question.choice/index 0}
                               :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}})

(def post-test-q8
  {:question.context/uuid "2b1184b8-8fa1-499a-921c-6fc7dad26cce"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo2-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 1
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "4a7afafb-6a73-453e-bd14-efe62fa56a8d"}
                                    :question.aggregates.response/guess-count 0
                                    :question.aggregates.response/unsure-count 0}
                                   {:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 3
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "6d631c07-ce0c-43c7-81a8-b203dcc0f417"}
                                    :question.aggregates.response/guess-count 1
                                    :question.aggregates.response/unsure-count 0}]
   :question.context/question {:question/other-enabled false
                               :question/type "single-answer"
                               :question/has-correctness true
                               :question/key false
                               :question/educator-feedback "<p><span>It is the PIs responsibility to ensure that the EMR system(s) used is(are) compliant with both ICH GCP and any other local regulations. PI should folow the requiremnets outlined in ICH GCP section 4.9.&nbsp;</span></p>\n<p><span>Electronic Medical Records Questionnaire (EMRQ) and EMRQ guidance were created to assist Sponsor in obtaining information form sites and showing due diligence by asking the PI to confirm that they are aware of the relevant requirements / regulations and are confident that their systems meet them.&nbsp;</span></p>\n<p><span>Reference: ICH GCP sections 4.0.0, 4.9.4, 4.9.5, 4.9.7, SOP Guidance on Interpretation of the EMRQ (Electronic Medical Records Questionnaire), SOP Electronic Medical Record Questionnaire (EMRQ)</span></p>",
                               :question/choices [{:question.choice/uuid "6660bdb2-44d9-4095-9633-e0266705a0eb",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body "The Site Monitor"}
                                                  {:question.choice/uuid "a8134596-dff8-427e-b52e-1924ccfd430c",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "The head of the institution’s IT department"}
                                                  {:question.choice/uuid "abfceb52-24ca-4191-9f18-dc3fe77223ee",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body "The maker of the EMR system"}
                                                  {:question.choice/uuid "6d631c07-ce0c-43c7-81a8-b203dcc0f417",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 3,
                                                   :question.choice/body "The Principal Investigator"}
                                                  {:question.choice/uuid "4a7afafb-6a73-453e-bd14-efe62fa56a8d",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 4,
                                                   :question.choice/body "The data entry supervisor"}]
                               :question/body "<p><span>Who is responsible to ensure an Electronic Medical Record (EMR) system is compliant with ICH-GCP and local regulations?&nbsp;</span></p>"
                               :question/results {:educator-feedback
                                                  "<p><span>It is the PIs responsibility to ensure that the EMR system(s) used is(are) compliant with both ICH GCP and any other local regulations. PI should folow the requiremnets outlined in ICH GCP section 4.9.&nbsp;</span></p>\n<p><span>Electronic Medical Records Questionnaire (EMRQ) and EMRQ guidance were created to assist Sponsor in obtaining information form sites and showing due diligence by asking the PI to confirm that they are aware of the relevant requirements / regulations and are confident that their systems meet them.&nbsp;</span></p>\n<p><span>Reference: ICH GCP sections 4.0.0, 4.9.4, 4.9.5, 4.9.7, SOP Guidance on Interpretation of the EMRQ (Electronic Medical Records Questionnaire), SOP Electronic Medical Record Questionnaire (EMRQ)</span></p>",
                                                  :correct-answer "6d631c07-ce0c-43c7-81a8-b203dcc0f417"}
                               :question/correct-answer {:question.choice/index 3}
                               :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}})

(def post-test-q9
  {:question.context/uuid "72f987c4-036a-4058-af19-353f3ecf5a7a"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo1-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 3,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "7b32469f-d77b-4b57-8742-599a7e471767"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "4321d6f8-1c22-492e-ab33-ee86ae7d2e07"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 0}]
   :question.context/question {:question/other-enabled false
                               :question/type "single-answer"
                               :question/has-correctness true
                               :question/key false
                               :question/educator-feedback "<p><span>The Investigation Product returned medication is the source i.e the number of pills returned. Once the pills are counted this data would be then documented on the IP accountability log, possibly the subject notes or it may be documented in other places depending on the practice of the trial facility and study requirements.</span></p>",
                               :question/choices [{:question.choice/uuid "99a5ca94-cec4-48ce-a21d-ec6c02cd20d3",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body "Patient notes"}
                                                  {:question.choice/uuid "4321d6f8-1c22-492e-ab33-ee86ae7d2e07",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body "IP Accountability Log"}
                                                  {:question.choice/uuid "7b32469f-d77b-4b57-8742-599a7e471767",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "Actual returned medication (i.e., pills)"}
                                                  {:question.choice/uuid "63cd7c48-c723-41ec-81d5-3c58af347c20",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body "Patient Diary"}]
                               :question/body "<p><span>The Investigational Product page of the CRF/eCRF records 10 pills returned at Visit 2. What is the true source, which must be verified prior to the CRF page being marked ‘SDV complete?'&nbsp;</span></p>"
                               :question/results {:educator-feedback
                                                  "<p><span>The Investigation Product returned medication is the source i.e the number of pills returned. Once the pills are counted this data would be then documented on the IP accountability log, possibly the subject notes or it may be documented in other places depending on the practice of the trial facility and study requirements.</span></p>",
                                                  :correct-answer "7b32469f-d77b-4b57-8742-599a7e471767"},
                               :question/correct-answer {:question.choice/index 2}
                               :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}})

(def post-test-q10
  {:question.context/uuid "445c8763-0039-4002-a745-aa083ec6b7e2"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid lo1-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0
                                    :question.aggregates.response/sure-count 4
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "457934c0-794f-46f7-ba9f-de9ddc566818"}
                                    :question.aggregates.response/guess-count 1
                                    :question.aggregates.response/unsure-count 0}]
   :question.context/question {:question/other-enabled false
                               :question/type "single-answer"
                               :question/has-correctness true
                               :question/key true
                               :question/educator-feedback
                               "<p><span>The sticky note is the first place the information was recorded (original).&nbsp; The Coordinator signed and dated the note, making it attributable.&nbsp; Assuming the other attributes are met, this original source document should be retained.&nbsp; In the other choices, information was not original.</span></p>",
                               :question/choices
                               [{:question.choice/uuid "77483435-c29a-4935-b9fa-8fa01f822fda",
                                 :question.choice/correct? false,
                                 :question.choice/index 0,
                                 :question.choice/body
                                 "The ECG printout was not available so the study coordinator transcribed the information into the patient chart"}
                                {:question.choice/uuid "426a7839-6732-411e-8abc-475024ed141b",
                                 :question.choice/correct? false,
                                 :question.choice/index 1,
                                 :question.choice/body
                                 "Study Coordinator noted that the data was illegible and re-wrote it into a new document to make it easier for the Site Monitor to read"}
                                {:question.choice/uuid "ae55d722-4807-481c-98c6-aac5d8c9af4d",
                                 :question.choice/correct? false,
                                 :question.choice/index 2,
                                 :question.choice/body
                                 "Study Coordinator entered data for the wrong subject so she blacked out the original entry and wrote in the correct value"}
                                {:question.choice/uuid "457934c0-794f-46f7-ba9f-de9ddc566818",
                                 :question.choice/correct? true,
                                 :question.choice/index 3,
                                 :question.choice/body
                                 "Study Coordinator noted the subject name, date, and vital signs on a sticky note, which they then signed, dated, and inserted into the subject's chart"}]

                               :question/body
                               "<p><span>Source data must be: Attributable - Legible - Contemporaneous - Original - Accurate - Complete. Therefore, which of the following situations is acceptable for source documentation?&nbsp;</span></p>",
                               :question/results
                               {:educator-feedback
                                "<p><span>The sticky note is the first place the information was recorded (original).&nbsp; The Coordinator signed and dated the note, making it attributable.&nbsp; Assuming the other attributes are met, this original source document should be retained.&nbsp; In the other choices, information was not original.</span></p>",
                                :correct-answer "457934c0-794f-46f7-ba9f-de9ddc566818"}
                               :question/correct-answer {:question.choice/index 3}
                               :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}})



(def raters-post-test-question-1
  {:question.context/uuid "lb4dc214-cf0f-4225-9ef8-2260a2098s5l"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid rater-lo1-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 5,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "83515d25-3bac-4d21-8c20-7c8ee2000401"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "d7451b5a-b47f-425f-98b7-94fc6e2a3402"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 2}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "93533f76-d792-4c0c-a6f9-a24861a50403"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "92132574-2dbc-4283-a2a7-05d28775c404"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "h7032574-2dbc-4283-a2a7-05d28775c405"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>No one tool is recognized as the best assessment to determine if a full dementia evaluation is needed. Some providers repeat patient assessment with an alternate tool to confirm initial findings before referral or initiation of full dementia evaluation.&nbsp;</span></p>",
                               :question/choices [{:question.choice/uuid "83515d25-3bac-4d21-8c20-7c8ee2000401",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "General Practitioner Assessment of Cognition (GPCOG)"}
                                                  {:question.choice/uuid "d7451b5a-b47f-425f-98b7-94fc6e2a3402",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "Mini-Cog"}
                                                  {:question.choice/uuid "93533f76-d792-4c0c-a6f9-a24861a50403",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "St. Louis University Mental Status Exam (SLUMS)"}
                                                  {:question.choice/uuid "92132574-2dbc-4283-a2a7-05d28775c404",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "Montreal Cognitive Assessment (MoCA)"}
                                                  {:question.choice/uuid "h7032574-2dbc-4283-a2a7-05d28775c405",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 4,
                                                   :question.choice/body
                                                   "None of the above"}],

                               :question/body "<p><span>Which of the following is the industry standard in brief structured assessments to determine if a full dementia evaluation is needed?</span></p>",

                               :question/results {:educator-feedback
                                                  "<p><span>No one tool is recognized as the best assessment to determine if a full dementia evaluation is needed. Some providers repeat patient assessment with an alternate tool to confirm initial findings before referral or initiation of full dementia evaluation.&nbsp;</span></p>",
                                                  :correct-answer "h7032574-2dbc-4283-a2a7-05d28775c405"},
                               :question/correct-answer {:question.choice/index 4},
                               :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}})

(def raters-post-test-question-2
  {:question.context/uuid "s5tdc214-cf0f-4225-9ef8-2260a2098k7p"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid rater-lo2-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 5,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "h3d15d25-3bac-4d21-8c20-7c8ee2000501"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "8nl51b5a-b47f-425f-98b7-94fc6e2a3502"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 2}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "1d033f76-d792-4c0c-a6f9-a24861a50503"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "pl232574-2dbc-4283-a2a7-05d28775c504"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>This is a correct drawing of the clock, so a score of 2 should be given. Mini-Cog scoring guidelines only give scores of 0 or 2 (pass or fail).&nbsp;</span></p>",
                               :question/choices [{:question.choice/uuid "h3d15d25-3bac-4d21-8c20-7c8ee2000501",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "0"}
                                                  {:question.choice/uuid "8nl51b5a-b47f-425f-98b7-94fc6e2a3502",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "1"}
                                                  {:question.choice/uuid "1d033f76-d792-4c0c-a6f9-a24861a50503",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "2"}
                                                  {:question.choice/uuid "pl232574-2dbc-4283-a2a7-05d28775c504",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 3,
                                                   :question.choice/body
                                                   "3"}],

                               :question/body "<p><span>The Mini-Cog asks patients to draw a clock setting the hands to 10 past 11.  Using the Mini-Cog scoring guidance, what score would you give this clock drawing?</span></p>",

                               :question/results {:educator-feedback
                                                  "<p><span>This is a correct drawing of the clock, so a score of 2 should be given.   Mini-Cog scoring guidelines only give scores of 0 or 2 (pass or fail).&nbsp;</span></p>",
                                                  :correct-answer "1d033f76-d792-4c0c-a6f9-a24861a50503"},
                               :question/correct-answer {:question.choice/index 2},
                               :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}})

(def raters-post-test-question-3
  {:question.context/uuid "5lkdc214-cf0f-4225-9ef8-2260a2098n73"
   :question.context/resources []
   :question.context/learning-objective {:learning-objective/uuid rater-lo3-uuid}
   :question.aggregates/percent-correct nil
   :question.aggregates/responses [{:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 5,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "gb615d25-3bac-4d21-8c20-7c8ee2000601"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 2,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "kl451b5a-b47f-425f-98b7-94fc6e2a3602"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 2}
                                   {:question.aggregates.response/no-confidence-count 0,
                                    :question.aggregates.response/sure-count 1,
                                    :question.aggregates.response/choice
                                    {:question.choice/uuid "jn533f76-d792-4c0c-a6f9-a24861a50603"},
                                    :question.aggregates.response/guess-count 0,
                                    :question.aggregates.response/unsure-count 1}]
   :question.context/question {:question/other-enabled false,
                               :question/type "single-answer",
                               :question/has-correctness true,
                               :question/key false,
                               :question/educator-feedback "<p><span>Informant interviewees should be instructed to compare the patient's current behavior to that of their behavior in the past 5-10 years.&nbsp;</span></p>",
                               :question/choices [{:question.choice/uuid "gb615d25-3bac-4d21-8c20-7c8ee2000601",
                                                   :question.choice/correct? true,
                                                   :question.choice/index 0,
                                                   :question.choice/body
                                                   "The patient's behavior 5 to 10 years ago"}
                                                  {:question.choice/uuid "kl451b5a-b47f-425f-98b7-94fc6e2a3602",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 1,
                                                   :question.choice/body
                                                   "The patient's behavior in the past 12 months"}
                                                  {:question.choice/uuid "jn533f76-d792-4c0c-a6f9-a24861a50603",
                                                   :question.choice/correct? false,
                                                   :question.choice/index 2,
                                                   :question.choice/body
                                                   "The patient's behavior in the past 2 years"}],

                               :question/body "<p><span>When conducting an informant interview using the GPCOG, the informant should be instructed to compare the patient's current behavior to:</span></p>",

                               :question/results {:educator-feedback
                                                  "<p><span>This is a correct drawing of the clock, so a score of 2 should be given.   Mini-Cog scoring guidelines only give scores of 0 or 2 (pass or fail).&nbsp;</span></p>",
                                                  :correct-answer "gb615d25-3bac-4d21-8c20-7c8ee2000601"},
                               :question/correct-answer {:question.choice/index 0},
                               :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}})

(def post-test
  {:assessment/questions [post-test-q1
                          post-test-q2
                          post-test-q3
                          post-test-q4
                          post-test-q5
                          post-test-q6
                          post-test-q7
                          post-test-q8
                          post-test-q9
                          post-test-q10]
   :questionnaire/uuid "4e4d1446-b722-4a21-b9f0-830bfdd74513"})

(def rater-post-test
  {:assessment/questions [raters-post-test-question-1
                          raters-post-test-question-2
                          raters-post-test-question-3]
   :questionnaire/uuid "5e4d1446-b722-4a21-b9f0-830bfdd74514"})

(def activity
  {:activity/learning-objectives learning-objectives
   :activity/moments moments
   :activity/post-test post-test
   :activity/uuid activity-uuid
   :activity/name "Data Integrity"})

(def rater-activity
  {:activity/learning-objectives rater-learning-objectives
   :activity/moments rater-moments
   :activity/post-test rater-post-test
   :activity/uuid rater-activity-uuid
   :activity/name "Cognitive Assessment Toolkit"})

(def janice-campos-external-id "9")

(def janice-campos
  {:external-user/full-name "Janice Campos",
   :user/uuid "a34f3f10-5625-4597-a16e-7e321c76481c",
   :external-user/id janice-campos-external-id
   :activity-session/readiness-label nil,
   :activity-session/mindset nil,
   :activity-session/pre-test {:questionnaire.attempts/first nil},
   :activity/moments
   [{:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}],
   :activity-session/started-at nil,
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 0,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 0,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 0,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 0,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness nil}],
   :activity-session/readiness nil,
   :activity-session/post-test
   {:questionnaire.attempts/count 0,
    :questionnaire.attempts/last nil,
    :questionnaire.attempts/first nil}})

(def william-taylor-external-id "6")

(def william-taylor
  {:external-user/full-name "William Taylor",
   :user/uuid "202ca936-023c-4478-beaa-fef94f84e901",
   :external-user/id william-taylor-external-id
   :activity-session/readiness-label nil,
   :activity-session/mindset nil,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating\n",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:53:10.360Z")}}
   :activity/moments
   [{:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}],
   :activity-session/started-at (t/instant "2021-02-26T21:53:10.360Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness nil}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 0,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label nil,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness nil}],
   :activity-session/readiness nil
   :activity-session/post-test
   {:questionnaire.attempts/count 0,
    :questionnaire.attempts/last nil,
    :questionnaire.attempts/first nil}})

(def oliver-wilson-external-id "5")

(def oliver-wilson
  {:external-user/full-name "Oliver Wilson",
   :user/uuid "feb5c09b-bf96-46f5-af43-f09a2c6da97b",
   :external-user/id oliver-wilson-external-id
   :activity-session/readiness-label :low,
   :activity-session/mindset :medium,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :guess,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :guessed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "I don't know",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :guessed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:44:17.692Z")}}
   :activity/moments
   [{:question.response/confidence :sure,
     :question.response/value {:question.choice/index 1},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence :unsure,
     :question.response/value {:question.choice/index 2},
     :question.response/correct? false,
     :question.response/status :failed,
     :moment/halo-consumed true,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}],
   :activity-session/started-at (t/instant "2021-02-23T21:44:22.122Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 1,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness 4}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 2.5}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 0,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 3}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 3,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :medium,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 5.5}],
   :activity-session/readiness 3.75,
   :activity-session/post-test
   {:questionnaire.attempts/count 3
    :questionnaire.attempts/last
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating logs",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:47:51.077Z")},
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 4},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:46:37.514Z")}}})

(def grace-brown-external-id "4")


;; It looks like we need to create question attempts like this:
(def grace-brown
  {:external-user/full-name "Grace Brown",
   :user/uuid "af8adbd1-5759-4d5a-9109-146f39b08435",
   :external-user/id grace-brown-external-id
   :activity-session/readiness-label :low,
   :activity-session/mindset :medium,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :guess,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :guessed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:37:33.602Z")}},
   :activity/moments
   [{:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence nil,
     :question.response/value nil,
     :question.response/correct? nil,
     :question.response/status :skipped,
     :moment/halo-consumed false,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}],
   :activity-session/started-at (t/instant "2021-02-26T21:37:38.881Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :medium,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 5.25}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 1,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 2.5}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 1,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 4.5}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 3,
     :learning-objective/first-post-test-correct-count 1,
     :learning-objective/readiness-label :low,
     :learning-objective/first-pre-test-correct-count 0,
     :learning-objective/readiness 3.5}],
   :activity-session/readiness 4.0,
   :activity-session/post-test
   {:questionnaire.attempts/count 2,
    :questionnaire.attempts/last
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:39:51.978Z")},
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 4}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :guessed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:38:51.560Z")}}})

(def sophie-jones-external-id "3")

(def sophie-jones
  {:external-user/full-name "Sophie Jones",
   :user/uuid "3992c959-ee5d-48c6-b7bf-1d3ce09bb3e5",
   :external-user/id sophie-jones-external-id
   :activity-session/readiness-label :high,
   :activity-session/mindset :medium,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? false,
       :question.response/status :guessed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? false,
       :question.response/status :guessed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:31:00.209Z")}},
   :activity/moments
   [{:question.response/confidence :guess,
     :question.response/value {:question.choice/index 0},
     :question.response/correct? false,
     :question.response/status :guessed,
     :moment/halo-consumed true,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence :sure,
     :question.response/value {:question.choice/index 3},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}]
   :activity-session/started-at (t/instant "2021-02-26T21:31:10.679Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 7.25}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 7.5}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :medium,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 6}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 3,
     :learning-objective/first-post-test-correct-count 3,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 8}]
   :activity-session/readiness 7.2,
   :activity-session/post-test
   {:questionnaire.attempts/count 1,
    :questionnaire.attempts/last
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:32:58.697Z")},
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:32:58.697Z")}}})

(def amelia-thomas-external-id "2")

(def amelia-thomas
  {:external-user/full-name "Amelia Thomas",
   :user/uuid "f375fc6b-dc80-4b0f-ad1e-9a386d2a7efa",
   :external-user/id amelia-thomas-external-id
   :activity-session/readiness-label :high,
   :activity-session/mindset :medium,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:04:47.986Z")}}
   :activity/moments
   [{:question.response/confidence :sure,
     :question.response/value {:question.choice/index 1},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence :sure,
     :question.response/value {:question.choice/index 3},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}]
   :activity-session/started-at (t/instant "2021-02-25T21:04:51.300Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 9}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 9}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 9}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 3,
     :learning-objective/first-post-test-correct-count 3,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 9}],
   :activity-session/readiness 9,
   :activity-session/post-test
   {:questionnaire.attempts/count 1,
    :questionnaire.attempts/last
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:08:25.121Z")},
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "Backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}
        {:question.choice/index 4}],
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :no-confidence,
       :question.response/value
       [{:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}
        {:question.choice/index :com.wsscode.pathom.core/not-found}],
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "b761336f-5edf-4ea5-a2d5-3879f4a4bfed"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:08:25.121Z")}}})

(def gauri-sharma-external-id "10")

(def gauri-sharma
  {:external-user/full-name "Gauri Sharma",
   :user/uuid "e199c402-582e-411a-8415-5b90fe3f3202",
   :external-user/id gauri-sharma-external-id
   :activity-session/readiness-label :high,
   :activity-session/mindset :high,
   :activity-session/pre-test
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :sure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 2}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T22:00:51.404Z")}}
   :activity/moments
   [{:question.response/confidence :sure,
     :question.response/value {:question.choice/index 1},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "5c17d3cf-eeb9-4fce-a7e6-58f55ab5f09a"}
    {:question.response/confidence :sure,
     :question.response/value {:question.choice/index 3},
     :question.response/correct? true,
     :question.response/status :passed,
     :moment/halo-consumed true,
     :moment/uuid "6d26bbcd-20ce-4cc3-8f19-debc6d201275"}],
   :activity-session/started-at (t/instant "2021-02-23T21:59:05.767Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "15dd6e45-6029-4442-b4e2-a5baf47fe647",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 7.5}
    {:learning-objective/uuid "16c6c141-e69b-4320-9a88-108acab6ef1b",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 1,
     :learning-objective/readiness-label :medium,
     :learning-objective/first-pre-test-correct-count 1,
     :learning-objective/readiness 5.75}
    {:learning-objective/uuid "1d00894a-d0df-4640-9e7f-527c822ed9fc",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 2,
     :learning-objective/first-post-test-correct-count 2,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 9}
    {:learning-objective/uuid "d301df5c-1817-4283-81bd-67b14903e7ec",
     :learning-objective/first-pre-test-count 2,
     :learning-objective/first-post-test-count 3,
     :learning-objective/first-post-test-correct-count 3,
     :learning-objective/readiness-label :high,
     :learning-objective/first-pre-test-correct-count 2,
     :learning-objective/readiness 8.5}],
   :activity-session/readiness 7.7,
   :activity-session/post-test
   {:questionnaire.attempts/count 1,
    :questionnaire.attempts/last
    {:questionnaire.attempt/questions
     [{:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :guessed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T22:03:28.981Z")},
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "a0e1f253-2a19-4904-99d6-f22bc169a4d4"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "e9af4990-8048-4445-b407-f0b93f05393f"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 2},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "ae026224-a48f-4b18-ada5-c15b207e2fa2"}
      {:question.response/confidence :no-confidence,
       :question.response/value "backdating",
       :question.response/correct? nil,
       :question.response/status :submitted,
       :question/uuid "52c5b358-861a-41dd-9d46-fb9b09dc8f52"}
      {:question.response/confidence :unsure,
       :question.response/value
       [{:question.choice/index 0}
        {:question.choice/index 1}
        {:question.choice/index 3}],
       :question.response/correct? false,
       :question.response/status :failed,
       :question/uuid "60c22946-5e28-493f-aaae-ab830bbd1081"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "2ae8ae7d-1134-4209-a617-79e3a905b6da"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 0},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "7d25e1a3-2e49-44d4-b186-2cce75e36e15"}
      {:question.response/confidence :unsure,
       :question.response/value {:question.choice/index 1},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "3127d0ad-18ac-402a-a488-e064855eee87"}
      {:question.response/confidence :guess,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :guessed,
       :question/uuid "24d68357-f18e-4b96-ad90-e8f7ddf88564"}
      {:question.response/confidence :sure,
       :question.response/value {:question.choice/index 3},
       :question.response/correct? true,
       :question.response/status :passed,
       :question/uuid "cbea2207-02cd-4035-9ffe-fa9999c47a3c"}],
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T22:03:28.981Z")}}})

(def joyce-deacon-external-id "43")

(def joyce-deacon
  {:external-user/full-name "Joyce Deacon"
   :user/uuid "d6nadbd1-5759-4d5a-9109-146f39b082h0"
   :external-user/id joyce-deacon-external-id
   :activity-session/readiness-label :high
   :activity-session/mindset :high
   :activity-session/pre-test
  ;;  Attempts
   {:questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :unsure
       :question.response/value {:question.choice/index 4}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 0}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 0}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2023-06-23T21:37:33.602Z")}}
   :activity/moments
   [{:question.response/confidence :unsure
     :question.response/value {:question.choice/index 2}
     :question.response/correct? true
     :question.response/status :passed
     :moment/halo-consumed false
     :moment/uuid "s4h7d3cf-eeb9-4fce-a7e6-58f55ab5f2hg"}
    {:question.response/confidence :sure
     :question.response/value {:question.choice/index 0}
     :question.response/correct? true
     :question.response/status :passed
     :moment/halo-consumed false
     :moment/uuid "d827d3cf-eeb9-4fce-a7e6-58f55ab5fl1w"}]
   :activity-session/started-at (t/instant "2023-06-23T21:37:38.881Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "s781df5c-1817-4283-81bd-67b14903ek2c"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 1
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 1
     :learning-objective/readiness 9}
    {:learning-objective/uuid "v6l1df5c-1817-4283-81bd-67b14903e7aq"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 1
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 0
     :learning-objective/readiness 9.2}
    {:learning-objective/uuid "g741df5c-1817-4283-81bd-67b14903ebj5"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 1
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 1
     :learning-objective/readiness 8.7}]
   :activity-session/readiness 9.0
   :activity-session/post-test
   {:questionnaire.attempts/count 1
    ;; I made the first and last have the same data because she only took the post test once.
    :questionnaire.attempts/last
    {:questionnaire.attempt/question

     [{:question.response/confidence :sure
       :question.response/value {:question.choice/index 4}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :sure
       :question.response/value {:question.choice/index 2}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :unsure
       :question.response/value {:question.choice/index 0}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2023-06-23T21:39:51.978Z")}
    ;; I made the first and last have the same data because she only took the post test once.
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :sure
       :question.response/value {:question.choice/index 4}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :sure
       :question.response/value {:question.choice/index 2}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :unsure
       :question.response/value {:question.choice/index 0}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:38:51.560Z")}}})

(def kelsey-ayers-external-id "7")

(def kelsey-ayers
  {:external-user/full-name "Kelsey Ayers"
   :user/uuid "f3hadbd1-5759-4d5a-9109-146f39b08k8p"
   :external-user/id kelsey-ayers-external-id
   :activity-session/readiness-label :low
   :activity-session/mindset :low
   :activity-session/pre-test
   ;;  Attempts
   {:questionnaire.attempts/first
    ;; Questions:
    {:questionnaire.attempt/questions
     [{:question.response/confidence :guess
       :question.response/value {:question.choice/index 0}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 3}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 1}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2023-06-23T21:37:33.602Z")}}
   :activity/moments
   [{:question.response/confidence :unsure
     :question.response/value {:question.choice/index 0}
     :question.response/correct? false
     :question.response/status :failed
     :moment/halo-consumed false
     :moment/uuid "s4h7d3cf-eeb9-4fce-a7e6-58f55ab5f2hg"}
    {:question.response/confidence :guess
     :question.response/value {:question.choice/index 0}
     :question.response/correct? true
     :question.response/status :passed
     :moment/halo-consumed false
     :moment/uuid "d827d3cf-eeb9-4fce-a7e6-58f55ab5fl1w"}]
   :activity-session/started-at (t/instant "2023-06-23T21:37:38.881Z")
   :activity/learning-objectives
   [{:learning-objective/uuid "s781df5c-1817-4283-81bd-67b14903ek2c"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 0
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 0
     :learning-objective/readiness 3}
    {:learning-objective/uuid "v6l1df5c-1817-4283-81bd-67b14903e7aq"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 0
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 0
     :learning-objective/readiness 3.8}
    {:learning-objective/uuid "g741df5c-1817-4283-81bd-67b14903ebj5"
     :learning-objective/first-pre-test-count 2
     :learning-objective/first-post-test-count 3
     :learning-objective/first-post-test-correct-count 0
     :learning-objective/readiness-label :low
     :learning-objective/first-pre-test-correct-count 0
     :learning-objective/readiness 5}]
   :activity-session/readiness 3.9
   :activity-session/post-test
   {:questionnaire.attempts/count 1
    ;;  The last attempt does not appear to be rendered on the page.
    :questionnaire.attempts/last
    {:questionnaire.attempt/question
     [{:question.response/confidence :unsure
       :question.response/value {:question.choice/index 4}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :unsure
       :question.response/value {:question.choice/index 2}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :sure
       :question.response/value {:question.choice/index 0}
       :question.response/correct? true
       :question.response/status :passed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2023-06-23T21:39:51.978Z")}
    :questionnaire.attempts/first
    {:questionnaire.attempt/questions
     [{:question.response/confidence :unsure
       :question.response/value {:question.choice/index 1}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "j361f253-2a19-4904-99d6-f22bc169a7jl"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 3}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "s5h1f253-2a19-4904-99d6-f22bc169al05"}
      {:question.response/confidence :guess
       :question.response/value {:question.choice/index 2}
       :question.response/correct? false
       :question.response/status :failed
       :question/uuid "fh31f253-2a19-4904-99d6-f22bc169ad47"}]
     :questionnaire.attempt/submitted-at (t/instant "2021-02-26T21:38:51.560Z")}}})

(def staff-lookup
  {"2" amelia-thomas
   "3" sophie-jones
   "4" grace-brown
   "5" oliver-wilson
   "6" william-taylor
   "7" kelsey-ayers
   "10" gauri-sharma
   "9" janice-campos
   "43" joyce-deacon})

(def staff
  [janice-campos
   william-taylor
   oliver-wilson
   grace-brown
   sophie-jones
   amelia-thomas
   gauri-sharma
   kelsey-ayers
   joyce-deacon])

(def staff-session
  {:activity-session/most-engaged [{:external-user/full-name "Gauri Sharma"
                                    :external-user/id gauri-sharma-external-id}]
   :activity-session/remediation-recommended [{:external-user/full-name "Gauri Sharma"
                                               :external-user/id gauri-sharma-external-id}
                                              {:external-user/full-name "Grace Brown"
                                               :external-user/id grace-brown-external-id}
                                              {:external-user/full-name "Oliver Wilson"
                                               :external-user/id oliver-wilson-external-id}]
   :activity-session/most-improved [{:external-user/full-name "Sophie Jones"
                                     :external-user/id sophie-jones-external-id}]
   :activity-session/most-ready [{:external-user/full-name "Amelia Thomas"
                                  :external-user/id amelia-thomas-external-id}]
   :activity-session/average-readiness 6.6
   :activity-session/average-team-readiness 7.2
   :activity-session/low-mindset-count 10
   :activity-session/medium-mindset-count 74
   :activity-session/high-mindset-count 16
   :activity-session/lower-quartile-readiness 5.5
   :activity-session/upper-quartile-readiness 7.8})

(def rater-staff-lookup
  {"7" kelsey-ayers
   "43" joyce-deacon})

(def rater-staff
  [kelsey-ayers
   joyce-deacon])

(def rater-staff-session
  {:activity-session/most-engaged [{:external-user/full-name "Gauri Sharma"
                                    :external-user/id gauri-sharma-external-id}]
   :activity-session/remediation-recommended [{:external-user/full-name "Gauri Sharma"
                                               :external-user/id gauri-sharma-external-id}
                                              {:external-user/full-name "Grace Brown"
                                               :external-user/id grace-brown-external-id}
                                              {:external-user/full-name "Oliver Wilson"
                                               :external-user/id oliver-wilson-external-id}]
   :activity-session/most-improved [{:external-user/full-name "Sophie Jones"
                                     :external-user/id sophie-jones-external-id}]
   :activity-session/most-ready [{:external-user/full-name "Amelia Thomas"
                                  :external-user/id amelia-thomas-external-id}]
   :activity-session/average-readiness 6.6
   :activity-session/average-team-readiness 7.2
   :activity-session/low-mindset-count 10
   :activity-session/medium-mindset-count 74
   :activity-session/high-mindset-count 16
   :activity-session/lower-quartile-readiness 5.5
   :activity-session/upper-quartile-readiness 7.8})

(defn manager-session [sub]
  {:user/uuid sub
   :>/staff-session staff-session
   :external-user/staff staff})

(defn fmt-staff-for-team-view
  [{:external-user/keys [id full-name]
    :activity-session/keys [readiness-label mindset started-at readiness]}]
  {:external-user/id id
   :external-user/full-name full-name
   :>/activity-session {:activity-session/readiness-label readiness-label
                        :activity-session/mindset mindset
                        :activity-session/started-at started-at
                        :activity-session/readiness readiness}})

(defn team-mock
  [sub]
  {:>/curriculum curriculum
   :>/activity (select-keys activity [:activity/uuid :activity/name])
   :>/manager {:external-user/id sub
               :external-user/staff (mapv fmt-staff-for-team-view staff)
               :>/staff-session staff-session}})

(defn learner-mock
  [learner-id]
  {:>/learner (assoc (get staff-lookup learner-id)
                     :activity/uuid activity-uuid)})

(def metadata-mock
  {:>/activity activity})

(defn rater-team-mock
  [sub]
  {:>/curriculum curriculum
   :>/activity (select-keys rater-activity [:activity/uuid :activity/name])
   :>/manager {:external-user/id sub
               :external-user/staff (mapv fmt-staff-for-team-view rater-staff)
               :>/staff-session rater-staff-session}})

(defn rater-learner-mock
  [learner-id]
  {:>/learner (assoc (get rater-staff-lookup learner-id)
                     :activity/uuid rater-activity-uuid)})

(def rater-metadata-mock
  {:>/activity rater-activity})
